import { gql, useMutation } from '@apollo/client';

import type { DeleteVehicleMutation, DeleteVehicleMutationVariables } from './__generated__/useDeleteVehicle.gql';

const DELETE_VEHICLE = gql`
  mutation DeleteVehicle($input: DeleteVehicleInput!) {
    deleteVehicle(input: $input)
  }
`;

/**
 * Removes a family `Vehicle` by id. The mutation returns the deleted id (no
 * updated entity to merge), so the row isn't evicted from the `GetVehicles` cache
 * automatically — callers pass `refetchQueries: ['GetVehicles']` on the call (or
 * refetch the list themselves) so the removal is reflected. The hook stays
 * side-effect-free.
 */
export const useDeleteVehicle = () => {
  return useMutation<DeleteVehicleMutation, DeleteVehicleMutationVariables>(DELETE_VEHICLE);
};
